"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawContract = void 0;
const core_1 = require("@ts-rest/core");
const draw_admin_contract_1 = require("./draw.admin.contract");
const draw_auth_contract_1 = require("./draw.auth.contract");
const draw_public_contract_1 = require("./draw.public.contract");
const c = (0, core_1.initContract)();
exports.drawContract = c.router({
    admin: draw_admin_contract_1.adminDrawContract,
    auth: draw_auth_contract_1.authDrawContract,
    public: draw_public_contract_1.publicDrawContract,
}, {
    pathPrefix: '/draw/draw',
    strictStatusCodes: true,
});
__exportStar(require("./draw.admin.contract"), exports);
__exportStar(require("./draw.auth.contract"), exports);
__exportStar(require("./draw.public.contract"), exports);
__exportStar(require("./models"), exports);
//# sourceMappingURL=index.js.map